import ToolbarButton from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarButton';

const ListBullet = () => (
  <ToolbarButton
    className="ql-list"
    value="bullet"
    text={__('Bulleted list')}
    iconName="list-ul"
    dataTestId="toolbar-list-bullet"
  />
);

export default ListBullet;
